import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RejectError } from '../../../typings'

type Payload = {
  tenantSourceId: string
  credentials: uui.domain.server.gps.telematics.Credential[]
}

/**
 * Refreshes GPS Data
 *
 * @private
 */
export const validateUpdateTenantSource = createAsyncThunk<
  // Return type of the payload creator
  void,
  // First argument to the payload creator
  Payload,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/gps/telematics/validateUpdateTenantSource', async (payload, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const result = await rpc('rpc/gps/telematics/validateUpdateTenantSource', {
      category: 'rpc',
      payload,
      type: 'rpc/gps/telematics/validateUpdateTenantSource',
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {validateUpdateTenantSource}`,
      { tags: ['rpc'] },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Creation of Telematics tenant source Failed`,
      error,
    })
  }
})
